import { PriceLine } from '../price-line';
import AdjustmentInvoice from '../invoice/adjustment-invoice';
import { SubProject } from './sub-project';
import ProductAsset from '../product-asset';
import Employee from '../product/employee';
import LoggedAction from '../logged-action';
import TilingAware from '../helper-interfaces/tiling-aware';
import ExternalSupplierAware from '../helper-interfaces/external-supplier-aware';
import LineWithHeaderFinished from 'src/app/display-model/line-with-header-finished';
import { ProjectPlacement } from './projectPlacement';
import { Tour } from '../tour/tour';
import RegisteredAction from '../registered-action';

export class Adjustment
  extends SubProject
  implements TilingAware, ExternalSupplierAware
{
  extraInfoAdjustment?: string;
  executed?: boolean;
  productId?: string;
  prices?: PriceLine[];
  adjustmentInvoices?: AdjustmentInvoice[];
  customerNeedsInvoice?: boolean;
  customerNeedsDesign?: boolean;
  adjustmentAssets?: ProductAsset[];
  designApproved?: boolean;
  designApprovalRegistration?: LoggedAction;
  designApprovalFollowup?: string;
  adjustmentDesigner?: Employee;
  needsDesign?: boolean;
  extraInfoDesign?: string;
  material?: string;
  size?: string;
  amountDesign?: string;
  designerHourBudget?: number;
  designerMinuteBudget?: number;
  spellCheck?: boolean;
  spellCheckRegistration?: LoggedAction;
  printByMutoh?: boolean;
  printByAgfa?: boolean;
  tiling?: boolean;
  numTilingHorizontal?: number;
  numTilingVertical?: number;
  designFollowUp?: string;
  designSentToCustomer?: boolean;
  designSentLog?: LoggedAction;
  designFinished?: boolean;
  designFinishedLog?: LoggedAction;
  printWorkReady?: boolean;
  needPrintwork?: boolean;
  printworkFollowUp?: string;
  adjustmentPrintworkHandler?: Employee;
  printWorkReadyRegistration?: LoggedAction;
  printworkExtraInfo?: string;
  atelierExtraInfo?: string;
  needFinish?: boolean;
  adjustmentFinisher?: Employee;
  finishDescription?: string;
  finishFollowUp?: string;
  finishReady?: boolean;
  finishReadyRegistration?: LoggedAction;
  readyToInvoice?: boolean;
  splitCosts?: boolean;
  invoiceNotes?: string;
  inpressLogo?: boolean;
  immoscoopLogo?: boolean;
  spottoLogo?: boolean;
  extraHoogwerker?: boolean;
  extraHoogwerkerDone?: boolean;
  extraHoogwerkerDescription?: string;
  extraHoogwerkerDeadline?: Date;
  extraHoogwerkerEmployee?: Employee;
  parkingBan?: boolean;
  parkingBanDone?: boolean;
  extraInfoParkingBan?: string;
  parkingBanDeadline?: Date;
  parkingBanEmployee?: Employee;
  needExtraSupplier?: boolean;
  needExtraSupplierDone?: boolean;
  extraInfoNeedExtraSupplier?: string;
  extraSupplierDeadline?: Date;
  extraSupplierEmployee?: Employee;
  needExtraMaterials?: boolean;
  needExtraMaterialsDone?: boolean;
  extraInfoNeedExtraMaterials?: string;
  extraMaterialsDeadline?: Date;
  extraMaterialsEmployee?: Employee;
  handleByAtelier?: boolean;
  createNewBoard?: boolean;
  subBoardsRequired?: boolean;

  // Only for display in projects table
  firstPlacerDisplay?: Employee;
  externalSupplierLines?: LineWithHeaderFinished[];
  externalSupplierDeadlines?: Date[];
  externalSupplierEmployees?: Employee[];

  // Only for display in placer tour item detail
  baseProjectPlacement?: ProjectPlacement;
  baseProjectTour?: Tour;
  baseProjectDoneRegistration?: RegisteredAction;

  constructor() {
    super();
    this.type = 'Adjustment';
    this.handleByAtelier = true;
  }
}
